import Ecomm from './assets/E-comm-web.PNG';
import Qr from './assets/Q.r code.PNG';
import Food from './assets/food_img.jpg';
import Article from './assets/blogging_website.jpg'



const data = [

    {
        id: 1,
        img: Ecomm,
        title: "La-ecommerce Mobile and Desktop view",
        git: "https://github.com/ANYIEKPON/ecommerce-1",
        demo: "https://la-ecommerce.netlify.app/"
    },

    {
        id: 2,
        img: Qr,
        title: "Qr-code Scanner Mobile and Desktop view",
        git: "https://github.com/ANYIEKPON/Qr-Code",
        demo: "https://quikresponse-generator.netlify.app/"
    },

    {
        id: 3,
        img: Food,
        title: "Klansfood Desktop view",
        git: "https://github.com/ANYIEKPON/klansfood-UI-UX",
        demo: "https://klansfood.netlify.app/"
    },

    {
        id: 4,
        img: Article,
        title: "Article-blog Desktop view",
        git: "https://github.com/ANYIEKPON/Articleblog",
        demo: "https://articleblog.netlify.app/"
        
    }


]

export default data;